import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'
import { createKambiBetRequest } from '@core/Areas/Quickbet/helpers/betting/kambiSports/utils/createBetRequest'
import { postValidateKambiSportsBet } from '@core/Data/Betting/kambiSports'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'

export const useGetKambiRewardsForSelection = (selection: KambiSportsSelection) => {
  const playerSessionId = useSelector(selectPlayerSessionId)

  const { data, isError } = useQuery({
    queryKey: queryKeys.kambiPlayerRewards,
    queryFn: () =>
      postValidateKambiSportsBet(createKambiBetRequest({ selection, investmentWin: 1 })),
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    enabled: !!playerSessionId,
  })

  React.useEffect(() => {
    // Clear data on unmount
    return () => queryClient.removeQueries({ queryKey: queryKeys.kambiPlayerRewards })
  }, [])

  if (isError || !data) return null

  return data.rewardInfo
}
